<template>
  <tbody>
    <tr
      v-for="productItem in productItems"
      :key="productItem.id"
    >
      <td
        v-if="isColumnDisplayed('product')"
      >
        {{ productItem && productItem.product && productItem.product.name }}
      </td>
      <td
        v-if="isColumnDisplayed('productPackType')"
      >
        {{ productItem && productItem.product_pack_type && productItem.product_pack_type.pack_type && productItem.product_pack_type.pack_type.name }}
      </td>
      <td
        v-if="isColumnDisplayed('supplier')"
      >
        {{ productItem && productItem.supplier && productItem.supplier.name }}
      </td>
      <td
        v-if="isColumnDisplayed('expirationDate')"
      >
        {{ (productItem && productItem.expiration_date) | date }}
      </td>
      <td
        v-if="isColumnDisplayed('count')"
      >
        {{ productItem && productItem.count }}
      </td>
      <td
        v-if="isColumnDisplayed('baseCount')"
      >
        {{ productItem && productItem.base_count }}
      </td>
      <td
        v-if="isColumnDisplayed('comment')"
      >
        {{ productItem && productItem.comment }}
      </td>
      <td
        v-if="isColumnDisplayed('unitPrice')"
      >
        {{ productItem && productItem.unit_price }}
      </td>
      <td
        v-if="isColumnDisplayed('netPrice')"
      >
        {{ productItem && productItem.net_price }}
      </td>
      <td
        v-if="isColumnDisplayed('vat')"
      >
        {{ isVatZero ? 0 : productItem && productItem.vat }}
      </td>
      <td
        v-if="isColumnDisplayed('declutterReason')"
      >
        {{ productItem && productItem.declutter_reason }}
      </td>
    </tr>
  </tbody>
</template>
<script>
  export default {
    props: {
      enabledColumns: {
        type: Array,
        default() {
          return ['product', 'productPackType', 'expirationDate', 'count', 'unitPrice', 'netPrice', 'vat'];
        },
        required: false,
      },
      isVatZero: {
        type: Boolean,
        default() {
          return false;
        },
        required: false,
      },
      items: {
        type: Array,
        default() {
          return [];
        },
        required: true,
      },
    },
    data() {
      return {
        productItems: [],
      }
    },
    mounted() {
      this.productItems = JSON.parse(JSON.stringify(this.items));
    },
    methods: {
      isColumnDisplayed(column) {
        return this.enabledColumns.includes(column);
      },
    }
  }
</script>
